export default __webpack_public_path__ + "static/media/slider-mobile-liiv.fae3ef88.jpg";